import {lazy} from 'react';
import {HistoryMapping} from './Constant';

export const HistoryRouterComponent = lazy(() => import('./view/HistoryRouterComponent'));

export default [
    {id: HistoryMapping.history, exact: true, component: HistoryRouterComponent},
];